export class LoaderModel {
    message?: string;
    isLoading: boolean = false;
}
